import { Search, X } from 'lucide-react';
import { Input } from '../components/ui/input';

export const SearchBar = ({ value, onChange, placeholder = "Buscar productos..." }) => {
    return (
        <div className="relative" data-testid="search-bar">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-stone-400" />
            <Input
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="search-input pl-12 pr-10 w-full"
                data-testid="search-input"
            />
            {value && (
                <button
                    onClick={() => onChange('')}
                    className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-stone-100 rounded-full transition-colors tap-feedback"
                    data-testid="search-clear"
                    aria-label="Limpiar búsqueda"
                >
                    <X className="h-4 w-4 text-stone-400" />
                </button>
            )}
        </div>
    );
};
